import { FC } from 'react'
import { useT } from '_metronic/i18n/Metronici18n'
import { SncrNumeroUsado } from '../core/_models'
import { SncrNumeroUsadoLinha } from './SncrNumeroUsadoLinha'

type IProps = {
  numeros: SncrNumeroUsado[]
}

/** Tabela de prescrições vistas pelo número SNCR: a lista do bloco e o resultado do localizador. */
export const SncrNumerosTabela: FC<IProps> = ({ numeros }) => {
  const { t } = useT()

  return (
    <div className='table-responsive'>
      <table className='table table-row-dashed align-middle gs-0 gy-3 mb-0'>
        <thead>
          <tr className='text-muted fw-bold fs-7 text-uppercase'>
            <th scope='col'>{t('sncr.numeros.col_numero')}</th>
            <th scope='col'>{t('sncr.numeros.col_data')}</th>
            <th scope='col'>{t('sncr.numeros.col_paciente')}</th>
            <th scope='col'>{t('sncr.numeros.col_atendimento')}</th>
            <th scope='col'>{t('sncr.numeros.col_situacao')}</th>
            <th scope='col'>
              <span className='visually-hidden'>{t('sncr.numeros.col_acoes')}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {numeros.map((numero) => (
            <tr key={numero.id}>
              <SncrNumeroUsadoLinha numero={numero} />
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
